import React, { useEffect, useMemo } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import NavBar from "@/components/NavBar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import HiringSolutions from "@/components/HiringSolutions";
import Process from "@/components/Process";
import Industries from "@/components/Industries";
import Specs from "@/components/Specs";
import Certifications from "@/components/Certifications";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Pricing from "@/components/Pricing";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

const REVEAL_THRESHOLD = 0.15;

const Home = () => {
  const observerOptions = useMemo(
    () => ({ threshold: REVEAL_THRESHOLD }),
    []
  );

  useEffect(() => {
    const targets = document.querySelectorAll(".reveal-left, .reveal-up");
    if (targets.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("inview");
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [observerOptions]);

  return (
    <div className="w-full bg-zinc-950 text-white">
      <NavBar />
      <main>
        <Hero />
        <Services />
        <HiringSolutions />
        <Process />
        <Industries />
        <Specs />
        <Certifications />
        <Testimonials />
        <FAQ />
        <Pricing />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App w-full min-h-screen overflow-x-hidden">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}>
            <Route index element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
